import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface AvoidSpecificClaimLanguageCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const AvoidSpecificClaimLanguageCard: React.FC<AvoidSpecificClaimLanguageCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'AvoidSpecificClaimLanguage') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Avoid Specific Claim Language"
      onEditClick={onEditClick}
    />
  );
};
